import { i18nPrice } from '@shared/fondof-fn/format/price'
import { parseAmount } from '@shared/fondof-fn/parse/amount'
import type { CartDeliveryGroupFragment } from '@shared/types/storefront/graphql'

export const toDelivery = (
  deliveryGroup: CartDeliveryGroupFragment | undefined
) => {
  if (!deliveryGroup?.selectedDeliveryOption) {
    return null
  }

  const estimatedCost = parseAmount(
    deliveryGroup.selectedDeliveryOption.estimatedCost.amount
  )
  const { currencyCode } = deliveryGroup.selectedDeliveryOption.estimatedCost

  return {
    estimatedCostParsed: i18nPrice(estimatedCost, currencyCode),
    estimatedCost,
    currencyCode,
  }
}
